export default __webpack_public_path__ + "static/media/ribbon-landing.190cdf2b.png";